import type { RootState } from "../../Reducers/ShopfrontReducers";
import type { ShopfrontThunk } from "../../Utilities/Generic/ActionsHelper";
import UUID from "../../Utilities/Generic/UUID";

export const REGISTER_SYSTEM_AUDIO_TRACK = "REGISTER_SYSTEM_AUDIO_TRACK";
export const REGISTER_AUDIO_TRACK = "REGISTER_AUDIO_TRACK";
export const REVOKE_AUDIO_TRACK = "REVOKE_AUDIO_TRACK";
export const UNBLOCK_AUDIO_TRACK = "UNBLOCK_AUDIO_TRACK";

interface AudioTrackData {
    id: string;
    name: string;
    track: string | null;
    integration?: string;
}

interface RegisterSystemAudioTrackAction {
    type: typeof REGISTER_SYSTEM_AUDIO_TRACK;
    data: {
        id: string;
    };
}

export interface RegisterAudioTrackAction {
    type: typeof REGISTER_AUDIO_TRACK;
    data: AudioTrackData;
}

export interface RevokeAudioTrackAction {
    type: typeof REVOKE_AUDIO_TRACK;
    data: {
        id: string;
    };
}

export interface UnblockAudioTrackAction {
    type: typeof UNBLOCK_AUDIO_TRACK;
    data: {
        id: string;
        track: string;
    };
}

export type AudioActionTypes =
    RegisterAudioTrackAction |
    RevokeAudioTrackAction |
    UnblockAudioTrackAction |
    RegisterSystemAudioTrackAction;

export interface AudioState {
    tracks: Array<AudioTrackData>;
    systemTrack: null | string;
}

export function registerAudioTrack(
    name: string,
    track: string | null,
    integration?: string
): RegisterAudioTrackAction {
    const id = UUID.generate();

    return {
        type: REGISTER_AUDIO_TRACK,
        data: {
            id,
            name,
            track,
            integration,
        },
    };
}

export function revokeAudioTrack(id: string): ShopfrontThunk<RevokeAudioTrackAction> {
    return (dispatch, getState) => {
        const state: RootState = getState();

        const found = state.audio.tracks.find(t => t.id === id);

        if(typeof found?.integration === "string") {
            localStorage.removeItem(`audio-permission-${found.integration}`);
            sessionStorage.setItem(`audio-permission-${found.integration}`, "false");
        }

        dispatch({
            type: REVOKE_AUDIO_TRACK,
            data: {
                id,
            },
        });
    };
}

export function unblockAudioTrack(
    id: string,
    track: string
): ShopfrontThunk<UnblockAudioTrackAction> {
    return (dispatch, getState) => {
        const state: RootState = getState();

        const found = state.audio.tracks.find(t => t.id === id);

        if(typeof found?.integration === "string") {
            localStorage.removeItem(`audio-permission-${found.integration}`);
            sessionStorage.setItem(`audio-permission-${found.integration}`, "true");
        }

        dispatch({
            type: UNBLOCK_AUDIO_TRACK,
            data: {
                id,
                track,
            },
        });
    };
}
